import * as z from "zod";
import {
  MerchantDashboardNameSchema,
  MerchantDashboardSummarySchema,
} from "./merchant-dashboard-fields";

export const createMerchantDashboard = {
  name: "createMerchantDashboard" as const,
  input: z.object({ name: MerchantDashboardNameSchema }),
  output: z.object({ dashboard: MerchantDashboardSummarySchema }),
};
